import { render, staticRenderFns } from "./StatGemstone.vue?vue&type=template&id=25ceeb4a&scoped=true&"
import script from "./StatGemstone.vue?vue&type=script&lang=js&"
export * from "./StatGemstone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ceeb4a",
  null
  
)

export default component.exports